// import React, { useState, useEffect, useCallback } from "react";
// import { Link } from "react-router-dom";
// import {
//   FiUsers,
//   FiDollarSign,
//   FiMic,
//   FiClipboard,
//   FiCalendar,
//   FiClock,
//   FiMapPin,
//   FiCheckCircle,
//   FiChevronRight,
//   FiActivity,
//   FiCheck,
//   FiX,
//   FiTag,
// } from "react-icons/fi";
// import api from "api/axios"; // Adjust path based on your project structure

// export default function EventDashboard() {
//   const [selectedOrganizer] = useState(
//     localStorage.getItem("company_id") || ""
//   );

//   const [loading, setLoading] = useState(true);

//   const [stats, setStats] = useState({
//     registeredVisitors: 0,
//     paidVisitors: 0,
//     totalRevenue: 0,
//     totalSpeakers: 0,
//     checkInsToday: 0,
//     programsRunning: 0,
//   });

//   const [latestScans, setLatestScans] = useState([]);
//   const [upcomingPrograms, setUpcomingPrograms] = useState([]);

//   // Fetch Dashboard Data from 3 APIs
//   const fetchDashboardData = useCallback(async () => {
//     if (!selectedOrganizer) return;
//     try {
//       setLoading(true);
//       const [statsRes, scansRes, programsRes] = await Promise.all([
//         api.get(`/dashboard/stats/${selectedOrganizer}`),
//         api.get(`/dashboard/latest-scans/${selectedOrganizer}`),
//         api.get(`/dashboard/upcoming-programs/${selectedOrganizer}`),
//       ]);

//       if (statsRes.data?.data) {
//         setStats(statsRes.data.data);
//       }
//       if (scansRes.data?.data) {
//         setLatestScans(scansRes.data.data);
//       }
//       if (programsRes.data?.data) {
//         setUpcomingPrograms(programsRes.data.data);
//       }
//     } catch (error) {
//       console.error("Failed to load dashboard data:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, [selectedOrganizer]);

//   useEffect(() => {
//     fetchDashboardData();
//   }, [fetchDashboardData]);

//   if (loading) {
//     return (
//       <div className="flex min-h-[60vh] items-center justify-center text-sm font-semibold text-gray-500">
//         Loading Event Dashboard...
//       </div>
//     );
//   }

//   return (
//     <div className="bg-slate-50/50 text-slate-800 min-h-screen p-4 font-['Poppins',sans-serif] sm:p-6 lg:p-8">
//       <div className="mx-auto max-w-7xl space-y-8">
//         {/* ================= STATS METRICS GRID ================= */}
//         <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
//           {/* Card 1: Registered Visitors */}
//           <div className="border-slate-200/80 shadow-xs group relative overflow-hidden rounded-2xl border bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:shadow-md">
//             <div className="flex items-start justify-between">
//               <div>
//                 <span className="text-400 text-[11px] font-bold uppercase">
//                   REGISTERED VISITORS
//                 </span>
//                 <p className="text-600 mt-2 text-[25px] font-bold">
//                   {stats.registeredVisitors.toLocaleString()}
//                 </p>
//               </div>
//               <div
//                 className="flex h-12 w-12 items-center justify-center rounded-2xl transition-colors duration-200"
//                 style={{
//                   backgroundColor:
//                     "color-mix(in srgb, var(--color-primary, #02a9e0) 12%, white)",
//                   color: "var(--color-primary, #02a9e0)",
//                 }}
//               >
//                 <FiUsers className="h-6 w-6" />
//               </div>
//             </div>
//             <div className="text-slate-500 mt-4 flex items-center gap-1.5 text-xs font-semibold">
//               <span>Total registrations</span>
//             </div>
//           </div>

//           {/* Card 2: Paid Visitors */}
//           <div className="border-slate-200/80 shadow-xs group relative overflow-hidden rounded-2xl border bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:shadow-md">
//             <div className="flex items-start justify-between">
//               <div>
//                 <span className="text-slate-400 text-[16px] font-bold uppercase tracking-wider">
//                   PAID VISITORS
//                 </span>
//                 <p className="text-slate-900 mt-2 text-3xl font-extrabold tracking-tight">
//                   {stats.paidVisitors.toLocaleString()}
//                 </p>
//               </div>
//               <div
//                 className="flex h-12 w-12 items-center justify-center rounded-2xl transition-colors duration-200"
//                 style={{
//                   backgroundColor: "color-mix(in srgb, #10b981 12%, white)",
//                   color: "#10b981",
//                 }}
//               >
//                 <FiTag className="h-6 w-6" />
//               </div>
//             </div>
//             <div className="text-emerald-600 mt-4 flex items-center gap-1.5 text-xs font-semibold">
//               <FiCheckCircle />
//               <span>Confirmed paid passes</span>
//             </div>
//           </div>

//           {/* Card 3: Total Revenue */}
//           <div className="border-slate-200/80 shadow-xs group relative overflow-hidden rounded-2xl border bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:shadow-md">
//             <div className="flex items-start justify-between">
//               <div>
//                 <span className="text-slate-400 text-[11px] font-bold uppercase tracking-wider">
//                   TOTAL REVENUE
//                 </span>
//                 <p className="text-slate-900 mt-2 text-3xl font-extrabold tracking-tight">
//                   {stats.totalRevenue.toLocaleString("en-US", {
//                     style: "currency",
//                     currency: "RON",
//                     maximumFractionDigits: 0,
//                   })}
//                 </p>
//               </div>
//               <div
//                 className="flex h-12 w-12 items-center justify-center rounded-2xl transition-colors duration-200"
//                 style={{
//                   backgroundColor: "color-mix(in srgb, #f59e0b 12%, white)",
//                   color: "#f59e0b",
//                 }}
//               >
//                 <FiDollarSign className="h-6 w-6" />
//               </div>
//             </div>
//             <div className="text-emerald-600 mt-4 flex items-center gap-1.5 text-xs font-semibold">
//               <span>Completed order sales</span>
//             </div>
//           </div>

//           {/* Card 4: Total Speakers */}
//           <div className="border-slate-200/80 shadow-xs group relative overflow-hidden rounded-2xl border bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:shadow-md">
//             <div className="flex items-start justify-between">
//               <div>
//                 <span className="text-slate-400 text-[11px] font-bold uppercase tracking-wider">
//                   TOTAL SPEAKERS
//                 </span>
//                 <p className="text-slate-900 mt-2 text-3xl font-extrabold tracking-tight">
//                   {stats.totalSpeakers}
//                 </p>
//               </div>
//               <div
//                 className="flex h-12 w-12 items-center justify-center rounded-2xl transition-colors duration-200"
//                 style={{
//                   backgroundColor: "color-mix(in srgb, #6366f1 12%, white)",
//                   color: "#6366f1",
//                 }}
//               >
//                 <FiMic className="h-6 w-6" />
//               </div>
//             </div>
//             <div className="mt-4 flex items-center gap-1.5 text-xs font-semibold text-indigo-600">
//               <span>Active session experts</span>
//             </div>
//           </div>

//           {/* Card 5: Check-ins Today */}
//           <div className="border-slate-200/80 shadow-xs group relative overflow-hidden rounded-2xl border bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:shadow-md">
//             <div className="flex items-start justify-between">
//               <div>
//                 <span className="text-slate-400 text-[11px] font-bold uppercase tracking-wider">
//                   CHECK-INS TODAY
//                 </span>
//                 <p className="text-slate-900 mt-2 text-3xl font-extrabold tracking-tight">
//                   {stats.checkInsToday.toLocaleString()}
//                 </p>
//               </div>
//               <div
//                 className="flex h-12 w-12 items-center justify-center rounded-2xl transition-colors duration-200"
//                 style={{
//                   backgroundColor:
//                     "color-mix(in srgb, var(--color-primary, #02a9e0) 12%, white)",
//                   color: "var(--color-primary, #02a9e0)",
//                 }}
//               >
//                 <FiClipboard className="h-6 w-6" />
//               </div>
//             </div>
//             <div
//               className="mt-4 flex items-center gap-1.5 text-xs font-semibold"
//               style={{ color: "var(--color-primary, #02a9e0)" }}
//             >
//               {/* <span
//                 className="h-2 w-2 animate-ping rounded-full"
//                 style={{ backgroundColor: "var(--color-primary, #02a9e0)" }}
//               /> */}
//               <span>Live gate scans recorded</span>
//             </div>
//           </div>

//           {/* Card 6: Total Programs */}
//           <div className="border-slate-200/80 shadow-xs group relative overflow-hidden rounded-2xl border bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:shadow-md">
//             <div className="flex items-start justify-between">
//               <div>
//                 <span className="text-slate-400 text-[11px] font-bold uppercase tracking-wider">
//                   TOTAL PROGRAMS
//                 </span>
//                 <p className="text-slate-900 mt-2 text-3xl font-extrabold tracking-tight">
//                   {stats.programsRunning}
//                 </p>
//               </div>
//               <div
//                 className="flex h-12 w-12 items-center justify-center rounded-2xl transition-colors duration-200"
//                 style={{
//                   backgroundColor: "color-mix(in srgb, #a855f7 12%, white)",
//                   color: "#a855f7",
//                 }}
//               >
//                 <FiCalendar className="h-6 w-6" />
//               </div>
//             </div>
//             <div className="mt-4 flex items-center gap-1.5 text-xs font-semibold text-purple-600">
//               <span>Scheduled event agenda</span>
//             </div>
//           </div>
//         </div>
//         {/* ================= 3. BOTTOM SECTION: SCANS & UPCOMING EVENTS ================= */}
//         <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
//           {/* LEFT SECTION: LATEST GATE SCANS (7 COLUMNS) */}
//           <div className="space-y-4 lg:col-span-7">
//             <div className="flex items-center justify-between">
//               <div>
//                 <h2 className="text-slate-900 text-lg font-bold">
//                   Latest Gate Check-Ins (Max 10)
//                 </h2>
//                 <p className="text-slate-500 text-xs">
//                   Live attendee scan logs from event scanners
//                 </p>
//               </div>
//               <Link
//                 to="/admin/visitor"
//                 className="inline-flex items-center gap-1 text-xs font-bold transition hover:opacity-80"
//                 style={{ color: "var(--color-primary, #02a9e0)" }}
//               >
//                 <span>View All</span>
//                 <FiChevronRight />
//               </Link>
//             </div>

//             <div className="border-slate-200/80 shadow-xs overflow-hidden rounded-2xl border bg-white">
//               <div className="overflow-x-auto">
//                 <table className="w-full text-left text-xs">
//                   {/* Table Header using PRIMARY COLOR */}
//                   <thead
//                     className="text-[11px] font-bold uppercase tracking-wider text-white"
//                     style={{ backgroundColor: "var(--color-primary, #02a9e0)" }}
//                   >
//                     <tr>
//                       <th className="px-6 py-3.5">VISITOR</th>
//                       <th className="px-6 py-3.5">COMPANY</th>
//                       <th className="px-6 py-3.5">LOCATION / TIME</th>
//                       <th className="px-6 py-3.5 text-right">STATUS</th>
//                     </tr>
//                   </thead>
//                   <tbody className="divide-slate-100 text-slate-700 divide-y">
//                     {latestScans.length === 0 ? (
//                       <tr>
//                         <td
//                           colSpan="4"
//                           className="text-slate-400 px-6 py-10 text-center"
//                         >
//                           No scan records found for this event yet.
//                         </td>
//                       </tr>
//                     ) : (
//                       latestScans.map((scan) => (
//                         <tr
//                           key={scan._id}
//                           className="hover:bg-slate-50/70 transition"
//                         >
//                           <td className="px-6 py-3.5">
//                             <div className="flex items-center gap-3">
//                               <div
//                                 className="shadow-xs flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-bold text-white"
//                                 style={{
//                                   backgroundColor:
//                                     "var(--color-primary, #02a9e0)",
//                                 }}
//                               >
//                                 {scan.initials}
//                               </div>
//                               <span className="text-slate-900 text-xs font-bold">
//                                 {scan.name}
//                               </span>
//                             </div>
//                           </td>
//                           <td className="text-slate-700 px-6 py-3.5 font-semibold">
//                             {scan.company}
//                           </td>
//                           <td className="text-slate-500 px-6 py-3.5 font-medium">
//                             <div className="flex flex-col">
//                               <span className="text-slate-800 font-semibold">
//                                 {scan.scanPlaceName}
//                               </span>
//                               <span className="text-slate-400 text-[10px]">
//                                 {scan.scanTime} • {scan.scannedBy}
//                               </span>
//                             </div>
//                           </td>
//                           <td className="px-6 py-3.5 text-right">
//                             <span
//                               className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[10px] font-bold ${
//                                 scan.allowed
//                                   ? "bg-emerald-50 text-emerald-700 border-emerald-200 border"
//                                   : "bg-rose-50 text-rose-700 border-rose-200 border"
//                               }`}
//                             >
//                               {scan.allowed ? <FiCheck /> : <FiX />}
//                               {scan.allowed ? "Allowed" : "Denied"}
//                             </span>
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>

//           {/* RIGHT SECTION: UPCOMING EVENT PROGRAMS LIST (5 COLUMNS) */}
//           <div className="space-y-4 lg:col-span-5">
//             <div className="flex items-center justify-between">
//               <div>
//                 <h2 className="text-slate-900 text-lg font-bold">
//                   Upcoming Event Programs
//                 </h2>
//                 <p className="text-slate-500 text-xs">
//                   Scheduled agenda & sessions
//                 </p>
//               </div>
//               <Link
//                 to="/admin/program"
//                 className="text-slate-500 hover:text-slate-900 inline-flex items-center gap-1 text-xs font-bold"
//               >
//                 <span>View Full Schedule</span>
//                 <FiChevronRight />
//               </Link>
//             </div>

//             <div className="space-y-3">
//               {upcomingPrograms.length === 0 ? (
//                 <div className="border-slate-200 text-slate-400 rounded-2xl border bg-white p-8 text-center text-xs">
//                   No upcoming programs found.
//                 </div>
//               ) : (
//                 upcomingPrograms.map((program) => (
//                   <div
//                     key={program._id}
//                     className="border-slate-200/80 shadow-xs group relative rounded-2xl border bg-white p-5 transition-all hover:shadow-md"
//                   >
//                     <div className="flex items-start justify-between gap-3">
//                       <h3 className="text-slate-900 text-sm font-bold leading-snug">
//                         {program.title}
//                       </h3>
//                       <span className="bg-slate-100 text-slate-600 shrink-0 rounded-md px-2 py-0.5 text-[10px] font-bold uppercase">
//                         {program.programType}
//                       </span>
//                     </div>

//                     <p className="text-slate-400 mt-1 flex items-center gap-1.5 text-xs font-semibold">
//                       <FiClock />
//                       <span>{program.time}</span>
//                     </p>

//                     <p className="text-slate-600 mt-2 line-clamp-2 text-xs leading-relaxed">
//                       {program.description}
//                     </p>

//                     {/* Speakers Tags */}
//                     {program.speakers && program.speakers.length > 0 && (
//                       <div className="mt-3 flex flex-wrap items-center gap-1.5">
//                         {program.speakers.map((spk) => (
//                           <span
//                             key={spk._id || spk.name}
//                             className="bg-slate-100 text-slate-700 inline-flex items-center gap-1 rounded-md px-2 py-1 text-[11px] font-semibold"
//                           >
//                             <FiMic className="text-slate-400" />
//                             {spk.name}
//                           </span>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                 ))
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// import React, { useState, useEffect, useCallback } from "react";
// import { Link } from "react-router-dom";
// import {
//   FiMic,
//   FiClock,
//   FiChevronRight,
//   FiCheck,
// } from "react-icons/fi";
// import {
//   HiUsers,
//   HiBanknotes,
//   HiCircleStack,
//   HiMicrophone,
//   HiTicket,
//   HiClipboardDocumentList,
// } from "react-icons/hi2";
// import api from "api/axios"; // Adjust path based on your project structure

// export default function EventDashboard() {
//   const [selectedOrganizer] = useState(
//     localStorage.getItem("company_id") || ""
//   );

//   const [loading, setLoading] = useState(true);

//   const [stats, setStats] = useState({
//     registeredVisitors: 0,
//     paidVisitors: 0,
//     totalRevenue: 0,
//     totalSpeakers: 0,
//     checkInsToday: 0,
//     programsRunning: 0,
//   });

//   const [latestScans, setLatestScans] = useState([]);
//   const [upcomingPrograms, setUpcomingPrograms] = useState([]);

//   // Fetch Dashboard Data from 3 APIs
//   const fetchDashboardData = useCallback(async () => {
//     if (!selectedOrganizer) return;
//     try {
//       setLoading(true);
//       const [statsRes, scansRes, programsRes] = await Promise.all([
//         api.get(`/dashboard/stats/${selectedOrganizer}`),
//         api.get(`/dashboard/latest-scans/${selectedOrganizer}`),
//         api.get(`/dashboard/upcoming-programs/${selectedOrganizer}`),
//       ]);

//       if (statsRes.data?.data) {
//         setStats(statsRes.data.data);
//       }
//       if (scansRes.data?.data) {
//         setLatestScans(scansRes.data.data);
//       }
//       if (programsRes.data?.data) {
//         setUpcomingPrograms(programsRes.data.data);
//       }
//     } catch (error) {
//       console.error("Failed to load dashboard data:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, [selectedOrganizer]);

//   useEffect(() => {
//     fetchDashboardData();
//   }, [fetchDashboardData]);

//   if (loading) {
//     return (
//       <div className="flex min-h-[60vh] items-center justify-center text-sm font-semibold text-slate-500">
//         Loading Event Dashboard...
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen p-4 font-['Poppins',sans-serif] text-slate-800 ">
//       <div className="mx-auto max-w-7xl space-y-6">
//         {/* ================= PAGE TITLE HEADER ================= */}
//         <div>
//           <h1 className="font-bold text-[24px] leading-[105%] tracking-[0%]">
//             Dashboard
//           </h1>
//           <p className="mt-1 font-normal text-[15px] leading-[130%] tracking-[0%] text-[#425F8D]">
//             Welcome back! Here's what's happening at the Horeca Summit.
//           </p>
//         </div>

//         {/* ================= 1. STATS METRICS GRID ================= */}
//         <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 sm:gap-5">
//           {/* Card 1: Registered Visitors */}
//           <div className="info-card">
//             <div className="flex items-start gap-4">
//               <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[16px] bg-[#EBF3FF] text-[#2563EB]">
//                 <HiUsers className="h-6 w-6" />
//               </div>
//               <div>
//                 <span className="info-card-title">
//                   REGISTERED VISITORS
//                 </span>
//                 <p className="mt-1 info-card-value">
//                   {stats.registeredVisitors.toLocaleString()}
//                 </p>
//                 <span className="mt-1 info-card-subtitle">
//                   Total registrations
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Card 2: Paid Visitors */}
//           <div className="info-card">
//             <div className="flex items-start gap-4">
//               <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[16px] bg-[#E6F8F0] text-[#10B981]">
//                 <HiBanknotes className="h-6 w-6" />
//               </div>
//               <div>
//                 <span className="info-card-title">
//                   PAID VISITORS
//                 </span>
//                 <p className="mt-1 info-card-value">
//                   {stats.paidVisitors.toLocaleString()}
//                 </p>
//                 <span className="mt-1 block info-card-subtitle">
//                   Confirmed paid passes
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Card 3: Total Revenue */}
//           <div className="info-card">
//             <div className="flex items-start gap-4">
//               <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[16px] bg-[#FFF6E5] text-[#F59E0B]">
//                 <HiCircleStack className="h-6 w-6" />
//               </div>
//               <div>
//                 <span className="info-card-title">
//                   TOTAL REVENUE
//                 </span>
//                 <p className="mt-1 info-card-value">
//                   {stats.totalRevenue.toLocaleString("en-US", {
//                     style: "currency",
//                     currency: "RON",
//                     maximumFractionDigits: 0,
//                   })}
//                 </p>
//                 <span className="mt-1 block info-card-subtitle">
//                   Completed order sales
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Card 4: Total Speakers */}
//           <div className="info-card">
//             <div className="flex items-start gap-4">
//               <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[16px] bg-[#F3E8FF] text-[#9333EA]">
//                 <HiMicrophone className="h-6 w-6" />
//               </div>
//               <div>
//                 <span className="info-card-title">
//                   TOTAL SPEAKERS
//                 </span>
//                 <p className="mt-1 info-card-value">
//                   {stats.totalSpeakers}
//                 </p>
//                 <span className="mt-1 block info-card-subtitle">
//                   Active session experts
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Card 5: Check-ins Today */}
//           <div className="info-card">
//             <div className="flex items-start gap-4">
//               <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[16px] bg-[#E0F2FE] text-[#0284C7]">
//                 <HiTicket className="h-6 w-6" />
//               </div>
//               <div>
//                 <span className="info-card-title">
//                   CHECK-INS TODAY
//                 </span>
//                 <p className="mt-1 info-card-value">
//                   {stats.checkInsToday.toLocaleString()}
//                 </p>
//                 <span className="mt-1 block info-card-subtitle">
//                   Live gate scans recorded
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Card 6: Total Programs */}
//           <div className="info-card">
//             <div className="flex items-start gap-4">
//               <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[16px] bg-[#FCE7F3] text-[#D946EF]">
//                 <HiClipboardDocumentList className="h-6 w-6" />
//               </div>
//               <div>
//                 <span className="info-card-title">
//                   TOTAL PROGRAMS
//                 </span>
//                 <p className="mt-1 info-card-value">
//                   {stats.programsRunning}
//                 </p>
//                 <span className="mt-1 block info-card-subtitle">
//                   Scheduled event agenda
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* ================= 2. BOTTOM SECTION: CHECK-INS TABLE & SESSIONS ================= */}
//         <div className="grid grid-cols-1 gap-6 lg:grid-cols-12 lg:gap-8">
//           {/* LEFT SECTION: LATEST GATE CHECK-INS (7 COLUMNS) */}
//           <div className="table-card-dashboard lg:col-span-7">
//             <div className="flex items-center justify-between">
//               <div>
//                 <h2 className="text-base font-bold text-[#1E293B] sm:text-lg">
//                   Latest Gate Check-Ins
//                 </h2>
//                 <p className="text-xs text-[#64748B]">
//                   Live attendee scan logs from event scanners
//                 </p>
//               </div>
//               {/* <Link
//                 to="/admin/visitor"
//                 className="inline-flex items-center gap-1 text-xs font-semibold text-[#0284C7] transition hover:text-[#0369A1]"
//               >
//                 <span>View All</span>
//                 <FiChevronRight />
//               </Link> */}
//             </div>

//             {/* TABLE WRAPPER WITH FIXED HEIGHT & INTERNAL SCROLL BAR */}
//             <div className="rounded-2xl border border-slate-100 bg-white shadow-sm">
//               <div className="h-[320px] overflow-y-auto overflow-x-auto thin-scrollbar">
//                 <table className="w-full text-left text-xs">
//                   {/* STATIC HEADER */}
//                   <thead className="sticky top-0 z-10 bg-[var(--color-primary-10)] text-[11px] font-bold uppercase tracking-wider text-[#64748B]">
//                     <tr>
//                       <th className="px-5 py-3.5">VISITOR</th>
//                       <th className="px-5 py-3.5">COMPANY</th>
//                       <th className="px-5 py-3.5">LOCATION / TIME</th>
//                       <th className="px-5 py-3.5 text-center">STATUS</th>
//                     </tr>
//                   </thead>
//                   <tbody className="divide-y divide-slate-100 text-[#334155]">
//                     {latestScans.length === 0 ? (
//                       <tr>
//                         <td
//                           colSpan="5"
//                           className="px-6 py-12 text-center text-xs text-[#94A3B8]"
//                         >
//                           No scan records found for this event yet.
//                         </td>
//                       </tr>
//                     ) : (
//                       latestScans.map((scan) => (
//                         <tr
//                           key={scan._id}
//                           className="transition hover:bg-slate-50/80"
//                         >
//                           <td className="px-5 py-3.5 font-bold text-[#0F172A]">
//                             {scan.name}
//                           </td>
//                           <td className="px-5 py-3.5 font-semibold text-[#334155]">
//                             {scan.company}
//                           </td>
//                           <td className="px-5 py-3.5 font-medium">
//                             <div className="flex flex-col">
//                               <span className="font-semibold text-[#0F172A]">
//                                 {scan.scanPlaceName}
//                               </span>
//                               <span className="text-[10px] text-[#94A3B8]">
//                                 {scan.scanTime} • {scan.scannedBy}
//                               </span>
//                             </div>
//                           </td>
//                           <td className="px-5 py-3.5 text-center">
//                             <span
//                               className={`inline-flex items-center gap-1 rounded-md px-2.5 py-1 text-[11px] font-bold ${
//                                 scan.allowed
//                                   ? "bg-[#E6F8F0] text-[#10B981]"
//                                   : "bg-[#FEE2E2] text-[#EF4444]"
//                               }`}
//                             >
//                               <FiCheck className="text-xs" />
//                               <span>{scan.allowed ? "Allowed" : "Denied"}</span>
//                             </span>
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>

//           {/* RIGHT SECTION: UPCOMING EVENT PROGRAMS LIST (5 COLUMNS) */}
//           <div className="table-card-dashboard lg:col-span-5">
//             <div className="flex items-center justify-between">
//               <div>
//                 <h2 className="text-base font-bold text-[#1E293B] sm:text-lg">
//                   Upcoming Event Programs
//                 </h2>
//                 <p className="text-xs text-[#64748B]">
//                   Scheduled agenda & sessions
//                 </p>
//               </div>
//               <Link
//                 to="/admin/program"
//                 className="inline-flex items-center gap-1 text-xs font-semibold text-[#0284C7] transition hover:text-[#0369A1]"
//               >
//                 <span>View Full Schedule</span>
//                 <FiChevronRight />
//               </Link>
//             </div>

//             <div className="space-y-3 h-[320px] overflow-y-auto overflow-x-auto thin-scrollbar">
//               {upcomingPrograms.length === 0 ? (
//                 <div className="rounded-2xl border border-slate-100 bg-white p-8 text-center text-xs text-[#94A3B8] shadow-sm">
//                   No upcoming programs found.
//                 </div>
//               ) : (
//                 upcomingPrograms.map((program) => (
//                   <div
//                     key={program._id}
//                     className="group relative rounded-2xl border border-slate-100 bg-white p-5 shadow-sm transition-all hover:shadow-md"
//                   >
//                     <div className="flex items-start justify-between gap-3">
//                       <h3 className="text-sm font-bold uppercase tracking-tight text-[#0F172A]">
//                         {program.title}
//                       </h3>
//                       <span className="shrink-0 rounded-full bg-[#E0F2FE] px-2.5 py-0.5 text-[10px] font-bold uppercase text-[#0284C7]">
//                         {program.programType || "MEETING"}
//                       </span>
//                     </div>

//                     <p className="mt-2 flex items-center gap-1.5 text-xs font-semibold text-[#64748B]">
//                       <FiClock className="text-[#0284C7]" />
//                       <span>{program.time}</span>
//                     </p>

//                     <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-[#64748B]">
//                       {program.description}
//                     </p>

//                     {/* Speakers Tags */}
//                     {program.speakers && program.speakers.length > 0 && (
//                       <div className="mt-3 flex flex-wrap items-center gap-2 pt-1 border-t border-slate-50">
//                         {program.speakers.map((spk) => (
//                           <span
//                             key={spk._id || spk.name}
//                             className="inline-flex items-center gap-1.5 text-[11px] font-bold text-[#0284C7]"
//                           >
//                             <FiMic className="text-xs" />
//                             {spk.name}
//                           </span>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                 ))
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  FiMic,
  FiClock,
  FiChevronRight,
} from "react-icons/fi";
import {
  HiUsers,
  HiBanknotes,
  HiCircleStack,
  HiMicrophone,
  HiClipboardDocumentList,
} from "react-icons/hi2";
import api from "api/axios"; // Adjust path based on your project structure

export default function EventDashboard() {
  const [selectedOrganizer] = useState(
    localStorage.getItem("company_id") || ""
  );

  const [loading, setLoading] = useState(true);

  const [stats, setStats] = useState({
    registeredVisitors: 0,
    paidVisitors: 0,
    totalRevenue: 0,
    totalSpeakers: 0,
    programsRunning: 0,
  });

  const [upcomingPrograms, setUpcomingPrograms] = useState([]);

  // Fetch Dashboard Data from APIs
  const fetchDashboardData = useCallback(async () => {
    if (!selectedOrganizer) return;
    try {
      setLoading(true);
      const [statsRes, programsRes] = await Promise.all([
        api.get(`/dashboard/stats/${selectedOrganizer}`),
        api.get(`/dashboard/upcoming-programs/${selectedOrganizer}`),
      ]);

      if (statsRes.data?.data) {
        setStats(statsRes.data.data);
      }
      if (programsRes.data?.data) {
        setUpcomingPrograms(programsRes.data.data);
      }
    } catch (error) {
      console.error("Failed to load dashboard data:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedOrganizer]);

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  if (loading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center text-sm font-semibold text-slate-500">
        Loading Event Dashboard...
      </div>
    );
  }

  return (
    <div className="min-h-screen p-4 font-['Poppins',sans-serif] text-slate-800">
      <div className="mx-auto max-w-7xl space-y-6">
        {/* ================= PAGE TITLE HEADER ================= */}
        <div>
          <h1 className="font-bold text-[24px] leading-[105%] tracking-[0%]">
            Dashboard
          </h1>
          <p className="mt-1 font-normal text-[15px] leading-[130%] tracking-[0%] text-[#425F8D]">
            Welcome back! Here's what's happening at the Horeca Summit.
          </p>
        </div>

        {/* ================= 1. STATS METRICS GRID ================= */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 sm:gap-5">
          {/* Card 1: Registered Visitors -> Navigates to /admin/visitor */}
          <Link
            to="/admin/visitor"
            className="info-card block transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
          >
            <div className="flex items-start gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[16px] bg-[#EBF3FF] text-[#2563EB]">
                <HiUsers className="h-6 w-6" />
              </div>
              <div>
                <span className="info-card-title">REGISTERED VISITORS</span>
                <p className="mt-1 info-card-value">
                  {stats.registeredVisitors.toLocaleString()}
                </p>
                <span className="mt-1 info-card-subtitle">
                  Total registrations
                </span>
              </div>
            </div>
          </Link>

          {/* Card 2: Paid Visitors -> Navigates to /admin/visitor */}
          <Link
            to="/admin/visitor"
            className="info-card block transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
          >
            <div className="flex items-start gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[16px] bg-[#E6F8F0] text-[#10B981]">
                <HiBanknotes className="h-6 w-6" />
              </div>
              <div>
                <span className="info-card-title">PAID VISITORS</span>
                <p className="mt-1 info-card-value">
                  {stats.paidVisitors.toLocaleString()}
                </p>
                <span className="mt-1 block info-card-subtitle">
                  Confirmed paid passes
                </span>
              </div>
            </div>
          </Link>

          {/* Card 3: Total Revenue */}
          <div className="info-card">
            <div className="flex items-start gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[16px] bg-[#FFF6E5] text-[#F59E0B]">
                <HiCircleStack className="h-6 w-6" />
              </div>
              <div>
                <span className="info-card-title">TOTAL REVENUE</span>
                <p className="mt-1 info-card-value">
                  {stats.totalRevenue.toLocaleString("en-US", {
                    style: "currency",
                    currency: "RON",
                    maximumFractionDigits: 0,
                  })}
                </p>
                <span className="mt-1 block info-card-subtitle">
                  Completed order sales
                </span>
              </div>
            </div>
          </div>

          {/* Card 4: Total Speakers -> Navigates to /admin/speaker */}
          <Link
            to="/admin/speakers"
            className="info-card block transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
          >
            <div className="flex items-start gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[16px] bg-[#F3E8FF] text-[#9333EA]">
                <HiMicrophone className="h-6 w-6" />
              </div>
              <div>
                <span className="info-card-title">TOTAL SPEAKERS</span>
                <p className="mt-1 info-card-value">{stats.totalSpeakers}</p>
                <span className="mt-1 block info-card-subtitle">
                  Active session experts
                </span>
              </div>
            </div>
          </Link>

          {/* Card 5: Total Programs -> Navigates to /admin/program */}
          <Link
            to="/admin/program"
            className="info-card block transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
          >
            <div className="flex items-start gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[16px] bg-[#FCE7F3] text-[#D946EF]">
                <HiClipboardDocumentList className="h-6 w-6" />
              </div>
              <div>
                <span className="info-card-title">TOTAL PROGRAMS</span>
                <p className="mt-1 info-card-value">
                  {stats.programsRunning}
                </p>
                <span className="mt-1 block info-card-subtitle">
                  Scheduled event agenda
                </span>
              </div>
            </div>
          </Link>
        </div>

        {/* ================= 2. FULL PAGE UPCOMING EVENT PROGRAMS (3 CARDS PER ROW) ================= */}
        <div className="space-y-4 pt-2">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-base font-bold text-[#1E293B] sm:text-lg">
                Upcoming Event Programs
              </h2>
              <p className="text-xs text-[#64748B]">
                Scheduled agenda & sessions
              </p>
            </div>
            <Link
              to="/admin/program"
              className="inline-flex items-center gap-1 text-xs font-semibold text-[#0284C7] transition hover:text-[#0369A1]"
            >
              <span>View Full Schedule</span>
              <FiChevronRight />
            </Link>
          </div>

          {/* GRID: 3 COLUMNS ON DESKTOP */}
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
            {upcomingPrograms.length === 0 ? (
              <div className="col-span-full rounded-2xl border border-slate-100 bg-white p-8 text-center text-xs text-[#94A3B8] shadow-sm">
                No upcoming programs found.
              </div>
            ) : (
              upcomingPrograms.map((program) => (
                <div
                  key={program._id}
                  className="group relative rounded-2xl border border-slate-100 bg-white p-5 shadow-sm transition-all hover:shadow-md"
                >
                  <div className="flex items-start justify-between gap-3">
                    <h3 className="text-sm font-bold uppercase tracking-tight text-[#0F172A]">
                      {program.title}
                    </h3>
                    <span className="shrink-0 rounded-full bg-[#E0F2FE] px-2.5 py-0.5 text-[10px] font-bold uppercase text-[#0284C7]">
                      {program.programType || "MEETING"}
                    </span>
                  </div>

                  <p className="mt-2 flex items-center gap-1.5 text-xs font-semibold text-[#64748B]">
                    <FiClock className="text-[#0284C7]" />
                    <span>{program.time}</span>
                  </p>

                  <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-[#64748B]">
                    {program.description}
                  </p>

                  {/* Speakers Tags */}
                  {program.speakers && program.speakers.length > 0 && (
                    <div className="mt-3 flex flex-wrap items-center gap-2 border-t border-slate-50 pt-2">
                      {program.speakers.map((spk) => (
                        <span
                          key={spk._id || spk.name}
                          className="inline-flex items-center gap-1.5 text-[11px] font-bold text-[#0284C7]"
                        >
                          <FiMic className="text-xs" />
                          {spk.name}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}